import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bold-label-info-row',
  templateUrl: './bold-label-info-row.component.html',
  styleUrls: ['./bold-label-info-row.component.scss']
})
export class BoldLabelInfoRowComponent  {
  @Input() labelIconLink?: string;
  @Input() icon?: string;
  @Input() label?: string = '';
  @Input() value?: string;
  @Input() noValuePlaceholder?: string = '-';
  @Input() isLoading = false;
}
